export default __webpack_public_path__ + "static/media/table_mockup_fill_2_seats.6a418a32.png";